import React, { useState, useEffect } from "react";
import { ButtonText } from "@loanbossinc/component-library";

import { PresetsDrawerHeader, PresetsDrawerCell, EditablePreset } from "./";

const SaveButton = ({ saveIsVisible, onSave, disabled }) => (
  <>
    {
      saveIsVisible &&
        <ButtonText
          disabled={disabled}
          className={`${disabled && "dsb-disabled"} deal-screener-buttons`}
          label="Save"
          onClick={() => onSave()}
        />
    }
  </>
);

const DropdownPresetsDrawer = ({
  onClosePresets,
  presets = [],
  setPresets = () => { },
  selectedPreset,
  setSelectedPreset,
  saveNewPresetIsSelected = false,
  onCloseSaveNewPresets,
  saveNewPreset,
  newPresetName,
  setNewPresetName,
  updateSelectedPreset,
  deleteDealScreenerFilterPreset
}) => {
  const [editPresetIsVisible, setEditPresetIsVisible] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("");
  const [backButtonPressAction, setBackButtonPressAction] = useState(() => () => { });
  const [saveButtonIsVisible, setSaveButtonIsVisible] = useState(false);
  const [saveButtonFunction, setSaveButtonFunction] = useState(() => () => { });
  const [saveButtonIsDisabled, setSaveButtonIsDisabled] = useState(true);
  const [presetsSortedFlag, setPresetsSortedFlag] = useState(false);

  useEffect(() => {
    determineHeaderTitle();
    determineBackButtonPressAction();
    determineSaveButtonIsVisible();
    determineSaveButtonFunction();
    determineSaveButtonIsDisabled();
  }, [editPresetIsVisible, saveNewPresetIsSelected, newPresetName, selectedPreset]);

  useEffect(() => {
    if (!editPresetIsVisible || !saveNewPresetIsSelected) {
      setNewPresetName("");
    }
  }, [editPresetIsVisible, saveNewPresetIsSelected]);

  useEffect(() => {
    if (!presetsSortedFlag) {
      setPresetsSortedFlag(true);
      setPresets([...presets]?.sort((a, b) => a.name.localeCompare(b.name)));
    }
  }, [presets]);

  const handleOnPresetClick = (id, name, body) => {
    setSelectedPreset({ id, name, body });
    onClosePresets();
  };

  const handleEditPresetButtonClicked = (id, name, body) => {
    setSelectedPreset({ id, name, body });
    setEditPresetIsVisible(true);
  };

  const closeEditPresets = () => setEditPresetIsVisible(false);
  const editPresetDrawerIsVisible = editPresetIsVisible && !saveNewPresetIsSelected;
  const saveNewPresetDrawerIsVisible = !editPresetIsVisible && saveNewPresetIsSelected;
  const defaultPresetDrawerIsVisible = !editPresetIsVisible && !saveNewPresetIsSelected;

  const determineHeaderTitle = () => {
    if (editPresetDrawerIsVisible) {
      setHeaderTitle("Rename filter");
    }
    if (saveNewPresetDrawerIsVisible) {
      setHeaderTitle("Save filter");
    }
    if (defaultPresetDrawerIsVisible) {
      setHeaderTitle("Saved Filters");
    }
  };

  const determineBackButtonPressAction = () => {
    if (editPresetDrawerIsVisible) {
      setBackButtonPressAction(() => () => {
        closeEditPresets();
        onCloseSaveNewPresets();
      });
    }

    if (saveNewPresetDrawerIsVisible) {
      setBackButtonPressAction(() => () => {
        onClosePresets();
        onCloseSaveNewPresets();
      });
    }

    if (defaultPresetDrawerIsVisible) {
      setBackButtonPressAction(() => () => onClosePresets());
    }
  };

  const determineSaveButtonIsVisible = () => {
    if (editPresetIsVisible || saveNewPresetIsSelected) {
      setSaveButtonIsVisible(true);
    }
    if (defaultPresetDrawerIsVisible) {
      setSaveButtonIsVisible(false);
    }
  };

  const determineSaveButtonFunction = () => {
    if (editPresetDrawerIsVisible) {
      setSaveButtonFunction(() => () => {
        updateSelectedPreset();
        closeEditPresets();
      });
    }

    if (saveNewPresetDrawerIsVisible) {
      setSaveButtonFunction(() => () => {
        saveNewPreset();
        onClosePresets();
        onCloseSaveNewPresets();
      });
    }
  };

  const determineSaveButtonIsDisabled = () => {
    if (!selectedPreset.name || !newPresetName) {
      setSaveButtonIsDisabled(true);
    }
    if (Boolean(selectedPreset?.name) || Boolean(newPresetName)) {
      setSaveButtonIsDisabled(false);
    }
  };

  const handleOnDeletePresetClicked = id => {
    deleteDealScreenerFilterPreset({ id });
    // This is an optimistic UI update
    setPresets(presets?.filter(preset => preset?.id !== id));
  };

  return (
    <div>
      <PresetsDrawerHeader
        title={headerTitle}
        onClosePresets={backButtonPressAction}
        saveButton={() => <SaveButton saveIsVisible={saveButtonIsVisible} onSave={saveButtonFunction} disabled={saveButtonIsDisabled} />}
      />
      {defaultPresetDrawerIsVisible && (!editPresetDrawerIsVisible || !saveNewPresetDrawerIsVisible) &&
                presets?.map(({ name = "", id, body }, idx) => <PresetsDrawerCell
                  key={idx}
                  presetName={name}
                  onPresetClicked={() => handleOnPresetClick(id, name, body)}
                  onEditButtonClicked={() => handleEditPresetButtonClicked(id, name, body)}
                  setEditPresetIsVisible={() => setEditPresetIsVisible(true)}
                  onDeletePresetClicked={() => handleOnDeletePresetClicked(id)}
                />)}
      {editPresetDrawerIsVisible && <EditablePreset selectedPreset={selectedPreset} setSelectedPreset={setSelectedPreset} />}
      {saveNewPresetDrawerIsVisible && <EditablePreset newPreset selectedPreset={newPresetName} setNewPresetName={setNewPresetName} />}
    </div>
  );
};

export default DropdownPresetsDrawer;
